<script setup lang="ts">
import { ref } from 'vue'
import ReportsMenu from '../reports/ReportsMenu.vue'
import { Permission } from '../../types/auth';
import { CommonFunctions, hasPermission } from '../../utils/CommonFunctions';
import IconComponent from "../../components/ui/common/IconComponent.vue";
import { FilterField } from './table';

const props = defineProps<{
  permissions?: Permission[]
  title?: string | null
  reports?: { id: string | null | undefined }[]
  filteredFields?: FilterField[]
  showFilter?: boolean
  showSearch?: boolean
  showCreate?: boolean
}>()

const search = ref('')

const emit = defineEmits<{
  (e: 'search', value: string): void
  (e: 'create'): void
  (e: 'filter'): void
  (e: 'report', reportId: string | number): void
}>()

const handleSearch = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    emit('search', search.value)
  }
}

const handleReport = (reportId: string | number) => {
  emit('report', reportId)
}

</script>

<template>
  <div class="md:flex items-center justify-between gap-4 mb-4">
    <div class="flex-1 max-w-md relative" id="table-search">
      <template v-if="showSearch">
      <IconComponent name="Search" class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"/>
      <input
      type="search"
      v-model="search"
      @keyup="handleSearch"
      placeholder="Search..."
      class="w-full pl-10 pr-10 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400"
      />
      <button
      v-if="search"
      @mouseenter="search = ''"
      @focus="search = ''"
      class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none"
      >
      <IconComponent name="Trash2" class="w-4 h-4" />
      </button>
    </template>
    </div>
    
    <div class="flex items-center gap-2 mt-2 md:mt-0">
      <ReportsMenu @select="handleReport" :reports="reports"  id="table-report" v-if="CommonFunctions.hasPermission(props.permissions, 'View Reports')"/>

      <slot name="table-table-header-actions"></slot>

      <button
        @click="$emit('filter')"
        v-if="(!props.filteredFields || props.filteredFields.length <= 0) && showFilter"
         id="table-filter"
        class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-grey-500 dark:focus:ring-black-400 flex items-center gap-2"
      >
        <IconComponent name="Filter" />
        Filters {{ props.filteredFields?.length ? `(${props.filteredFields.length})` : '' }}
      </button>

      <button
        @click="$emit('create')"
        v-if="hasPermission(props.permissions, 'Create') && showCreate"
        eventtype="info"
         id="table-create"
        class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 flex items-center gap-2"
      >
        <IconComponent name="Plus" />
        New
      </button>
    </div>
  </div>
</template>